import { __spreadArray } from "tslib";
import { EditorEventType, EditorSetupEventType, } from '../common/editor-events';
import { SDKEventType } from '../common/events';
import { ViewerSetupEventType, ViewerEventType, } from '../common/viewer-events';
var LOGGER_PREFIX = 'viewer-SDK: ';
var noop = function () { };
var ViewerSdk = /** @class */ (function () {
    function ViewerSdk(_a) {
        var shouldLog = _a.shouldLog, origin = _a.origin, _b = _a.onReady, onReady = _b === void 0 ? noop : _b;
        this.messageHandlers = {};
        this.onReady = noop;
        if (origin === false) {
            console.warn(LOGGER_PREFIX, 'dengariously set init sdk in non-secure mode');
        }
        this.origin = origin || '*';
        this.onReady = onReady;
        this.logger = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (shouldLog) {
                console.log.apply(console, __spreadArray([LOGGER_PREFIX], args, false));
            }
        };
        this.logger('new viewer instance');
        this.setupWindowListener();
    }
    ViewerSdk.prototype.setupWindowListener = function () {
        var _this = this;
        window.addEventListener('message', function (e) {
            if (e.data.scope !== SDKEventType.setup) {
                return;
            }
            switch (e.data.type) {
                case EditorSetupEventType.sendMessagePort:
                    _this.logger('got message port');
                    _this.viewerPort = e.ports[0];
                    _this.setupPortListener();
                    break;
                default:
            }
        });
        this.sendPortRequest();
    };
    ViewerSdk.prototype.sendPortRequest = function () {
        var message = {
            scope: SDKEventType.setup,
            type: ViewerSetupEventType.readyForPort,
        };
        window.parent.postMessage(message, this.origin);
        this.logger('sent port request');
    };
    ViewerSdk.prototype.setupPortListener = function () {
        var _this = this;
        if (!this.viewerPort) {
            throw new Error('tried to listen on port before it was received');
        }
        this.viewerPort.addEventListener('message', function (e) {
            var _a;
            _this.logger('got a message: ', (_a = e.data) === null || _a === void 0 ? void 0 : _a.type, e.data);
            var fn = _this.messageHandlers[e.data.type] ||
                (function () {
                    return Promise.reject(new Error("Handler was not defined on viewer for type: ".concat(e.data.type)));
                });
            fn(e.data.payload)
                .then(function (res) {
                return _this.resolveRequest(e.data.id, res);
            })
                .catch(function (err) { return _this.rejectRequest(e.data.id, err); });
            switch (e.data.type) {
                case EditorEventType.updatePageStructure:
                    _this.logger('update structure');
                    break;
                case EditorEventType.updateBranding:
                    _this.logger('update branding');
                    break;
                case EditorEventType.navigateToPage:
                    _this.logger('navigate');
                    break;
                case EditorEventType.updateComponent:
                    _this.logger('update component');
                    break;
                case EditorEventType.updateCustomFields:
                    _this.logger('update custom fields');
                    break;
                case EditorEventType.getCompiledTemplate:
                    _this.logger('get compiled templates');
                    break;
                default:
                    _this.logger('no handler for this message', e.data);
                    throw new Error('unsupported event type');
            }
        });
        this.viewerPort.start();
        this.logger('registered to editor events');
        this.notifyReady();
        this.onReady();
    };
    ViewerSdk.prototype.resolveRequest = function (id, res) {
        this.sendMessage({
            scope: SDKEventType.sdk,
            type: ViewerEventType.success,
            id: id,
            payload: res,
        });
    };
    ViewerSdk.prototype.rejectRequest = function (id, err) {
        this.sendMessage({
            scope: SDKEventType.sdk,
            type: ViewerEventType.error,
            id: id,
            payload: err,
        });
    };
    ViewerSdk.prototype.notifyReady = function () {
        this.sendMessage({ scope: SDKEventType.sdk, type: ViewerEventType.ready });
    };
    ViewerSdk.prototype.onPageUpdate = function (handler) {
        this.messageHandlers[EditorEventType.updatePageStructure] = handler;
    };
    ViewerSdk.prototype.onBrandingUpdate = function (handler) {
        this.messageHandlers[EditorEventType.updateBranding] = handler;
    };
    ViewerSdk.prototype.onNavigate = function (handler) {
        this.messageHandlers[EditorEventType.navigateToPage] = handler;
    };
    ViewerSdk.prototype.onComponentUpdate = function (handler) {
        this.messageHandlers[EditorEventType.updateComponent] = handler;
    };
    ViewerSdk.prototype.onUpdateCustomFields = function (handler) {
        this.messageHandlers[EditorEventType.updateCustomFields] = handler;
    };
    ViewerSdk.prototype.onGetCompiledTemplate = function (handler) {
        this.messageHandlers[EditorEventType.getCompiledTemplate] = handler;
    };
    ViewerSdk.prototype.sendMessage = function (event) {
        if (!this.viewerPort) {
            throw new Error('tried to send a message before port was received');
        }
        this.viewerPort.postMessage(event);
        this.logger('sent message', event);
    };
    return ViewerSdk;
}());
export { ViewerSdk };
//# sourceMappingURL=viewer-sdk.js.map